<template>
  <div id="Facilities">
    <v-dialog v-model="dialogHelp" persistent style="margin-left: 95%;" max-width="750px" :retain-focus="false">
      <template v-slot:activator="{ on }">
        <v-btn color="green" slot="activator" v-on="on" medium fab right absolute>
          <v-icon color="white">fas fa-info</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="green" height="50px">
          <v-toolbar-title style="color: white; font-size: 150%">Hilfe</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn small @click="closeHelp" icon>
            <v-icon color="white">fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text style="font-size: 120%;">
          <p>
            Auf dieser Seite können Sie im oberen Eingabefeld eine Ihrer Anlagen hinzufügen.
            <br>In Folge erscheint in der unteren Tabelle ein Datensatz mit dem Anlagenamen.
            <br>Mit „Plus“ können Sie ein Seil dieser Anlage hinzuzufügen.
            <br>Mit dem „Pfeil nach unten“ alle Seile dieser Anlage anzeigen.
            <br>Mit dem „Pfeil nach rechts“ die Berechnung starten.
            <br>Mit „Papierkorb“ den Datensatz löschen.
            <br>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container class="AddFacility">
      <h1 class="Heading">Anlage hinzufügen:</h1>
      <v-divider></v-divider>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="fName"
            @keyup.enter="addFacility"
            label="Anlagenname"
            class="txtField"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn @click="addFacility" fab dark color="blue" small id="addBtn">
            <v-icon v-text="'fas fa-plus'" dark></v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-data-table
      :headers="header"
      :items-per-page="10"
      :items="facList"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      class="vTable"
      item-key="id"
      no-data-text="Noch keine Anlagen vorhanden - erzeugen Sie eine mit ''Anlange hinzufügen''"
    >
      <template slot="item" slot-scope="props">
        <!-- <tr @click="props.expanded = !props.expanded; setFacID(props.item.id);"-->
          <tr>
          <!-- <tr @click="setFacID(props.item.id);"> -->
          <td class="tdFontSize" style="font-size: 120%">{{ props.item.name }}</td>
          
          <td style="align-items: left; justify-content: left;" class="text-xs-center">
            <v-dialog v-model="dialog" persistent max-width="500px" :retain-focus="false">
              <template v-slot:activator="{ on }">
              <v-btn color="blue" fab x-small
                v-on="on"
                @click="setSelected(props.item.id); setFacID(props.item.id, props.item);"
              >
                <v-icon v-text="'fas fa-plus'" small color="white"></v-icon>
              </v-btn>
              </template>

              <v-content>
                <v-card>
                  <v-toolbar color="#2E9AFE" height="50px">
                    <v-toolbar-title style="color: white; font-size: 180%">Seil hinzufügen</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn small @click="close" icon>
                      <v-icon color="white">fas fa-times</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-img
                    src="../statics/images/Seile.jpg"
                    height="150px"
                    style="border: 1px solid black"
                  ></v-img>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout row>
                        <v-flex>
                          <v-select
                            v-model="select"
                            :items="selectableRopes"
                            label="Seilart"
                            attach
                          ></v-select>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            v-model="ropeName"
                            label="Seilbezeichnung / Norm"
                            @keyup.enter="addRope(selectedFac);"
                            style="width: 150%;"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-btn
                            @click="addRope(selectedFac)"
                            fab
                            dark
                            color="blue"
                            small
                            id="btnAddRope"
                          >
                            <v-icon dark>fas fa-plus</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-container>
                    <br>
                    <br>
                    <br>
                  </v-card-text>
                </v-card>
              </v-content>
            </v-dialog>
          </td>
          <td class="text-xs-center">
            <v-btn color="blue" fab x-small
            @click="setFacID(props.item.id, props.item);">
              <v-icon color="white">fas fa-sort-down</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center">
            <v-dialog v-model="facDelDialog" persistent max-width="290" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="red" fab x-small v-on="on" @click="setFacToDelete(props.item.id)">
                  <v-icon small color="white">fas fa-trash-alt</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">Wollen Sie die Anlage wirklich löschen?</v-card-title>
                <v-card-text>Beim Bestätigen wird die Anlage gelöscht und kann nicht mehr wieder aufgerufen werden. Sind Sie sich sicher?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue" outlined text @click="facDelDialog = false">Nein</v-btn>
                  <v-btn
                    color="blue"
                    text
                    @click="facDelDialog = false; deleteFac()"
                  >Ja</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </tr>
      </template>
      <!-- <template slot="expanded-item" slot-scope="props"> -->
      <template v-slot:expanded-item="{header}">
        <tr class="datatable__expand-row">
          <td class="datatable__expand-col datatable__expand-col--expanded" colspan="4">
        <v-card text>
          <v-divider></v-divider>
          <v-data-table
            dark
            hide-default-footer
            :headers="headerRope"
            :items="ropesOfFacList"
            :single-expand="false"
            item-key="id"
            no-data-text="Noch keine Seile vorhanden - erzeugen Sie eines mit + bei Seil hinzufügen"
          >
            <template slot="item" slot-scope="propsRope">
              <tr>
                <td class="tdFontSize" style="font-size: 120%">{{propsRope.item.ropen}}</td>
                <td class="tdFontSize" style="font-size: 120%">{{propsRope.item.rope}}</td>
                <td style="align-items: left; justify-content: left;" class="text-xs-center">
                  <v-btn
                    fab x-small
                    @click="startInspection(propsRope.item.id)"
                    color="white"
                  >
                    <v-icon color="blue">fas fa-play-circle</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-center" style="font-size: 120%;">{{propsRope.item.interval}}</td>
                <td style="align-items: left; justify-content: left;" class="text-xs-center">
                  <v-dialog v-model="ropeDelDialog" persistent max-width="290" :retain-focus="false">
                    <template v-slot:activator="{ on }">
                      <v-btn color="red" fab x-small v-on="on" @click="setRopeToDelete(propsRope.item.id);">
                        <v-icon small color="white">fas fa-trash-alt</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="headline">Wollen Sie die Anlage wirklich löschen?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue" outlined text @click="ropeDelDialog = false">Nein</v-btn>
                        <v-btn
                          color="blue"
                          text
                          @click="ropeDelDialog = false; deleteRo()"
                        >Ja</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          
        </v-card>
        </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["int"],
  name: "Facilities",
  data() {
    return {
      id: 0,
      expanded: [],
      select: "Litzenseil",
      selectableRopes: [
        "Zugseil (Litzenseil)",
        "Förderseil (Litzenseil)",
        // "Tragseil (Litzenseil)", //nicht in Norm enthalten
        "Tragseil (Seil vollverschlossen)"
      ],
      singleExpand: true,
      dialog: false,
      dialogHelp: false,
      selectedFac: 0,
      fName: "",
      ropeName: "",
      test: false,
      tampID: 0,
      // facList: [],
      ropesOfFacList: [],
      idCounter: -1,
      idRopeCounter: -1,
      id: -1,
      idInspection: 0,
      ropeXID: 0,
      facilityXID: 0,
      facDelDialog: false,
      ropeDelDialog: false,
      InspectionDone: false,
      facToDelete: -1,
      ropeToDelete: -1,
      headerRope: [
        {
          text: "Seilbezeichnung / Norm",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Seilart",
          sortable: false,
          value: "ropename"
        },
        {
          text: "Prüfungsintervall berechnen",
          value: "durchfuehren",
          sortable: false,
          align: "left"
        },
        {
          text: "Maximales Prüfungsintervall für die Sichtprüfung",
          value: "intervall",
          sortable: false,
          align: "left"
        },
        {
          text: "Seil entfernen",
          sortable: false,
          align: "left"
        }
      ],
      header: [
        {
          text: "Anlagenname",
          sortable: false,
          align: "left"
        },
        { text: "Seil hinzufügen", value: "seil", sortable: false, align: "left" },
        { text: "Seile anzeigen", sortable: false, align: "left" },
        { text: "Anlage entfernen", sortable: false, align: "left" },
        // { text: "expan", value: 'data-table-expand' },
      ]
    };
  },
  methods: {
    setFacToDelete(id){
      this.facToDelete = id;
    },
    setRopeToDelete(id){
      this.ropeToDelete = id;
    },
    addFacility() {
      console.log("test");
      if (this.fName.trim() != "") {
        this.id = this.id + 1;
        this.$store.dispatch("addFacility", {
          id: this.id,
          name: this.fName,
          ropeList: []
        });
        
        this.fName = "";
      }
    },
    setSelected(id) {
      this.selectedFac = id;
    },
    deleteFac() {
      console.log(this.facToDelete);
      this.$store.dispatch("deleteFac", this.facToDelete);
      var o = this.facList.find(x => x.id === this.facToDelete);
      this.facList.splice(this.facList.indexOf(o), 1);
    },
    addRope(index) {
      console.log(index);
      this.idRopeCounter = this.idRopeCounter + 1;
      if (this.select != "" && this.ropeName != "") {
        var o = this.facList.find(x => x.id === index);
        var facilityIndex = this.facList.indexOf(o);
        this.facilityXID = facilityIndex;

        this.$store.dispatch("addRopeToFacility", {
          // idRopeCounter: this.idRopeCounter,
          interval: "nicht festgelegt",
          rope: this.select,
          ropen: this.ropeName,
          facility_id: index
        });
      }
      this.ropeName = "";
      this.dialog = false;
      // this.expanded = true;
    },
    deleteRo() {
      console.log(this.ropeToDelete, this.tampID);
      this.$store.dispatch("deleteRope", this.ropeToDelete);
      var o = this.facList.find(x => x.id === this.tampID);
      var facIndex = this.facList.indexOf(o);
      var e = this.facList[facIndex].ropeList.find(
        x => x.id === this.ropeToDelete
      );
      var ropeIndex = this.facList[facIndex].ropeList.indexOf(e);
      this.ropeXID = ropeIndex;
      this.facilityXID = facIndex;
      console.log(facIndex + " " + ropeIndex);
      this.facList[facIndex].ropeList.splice(ropeIndex, 1);
    },
    startInspection(ropeID) {
      this.idInspection = this.idInspection + 1;
      var o = this.facList.find(x => x.id === this.tampID);
      var facIndex = this.facList.indexOf(o);
      let fac = o.id // should work
      var e = this.facList[facIndex].ropeList.find(
        x => x.id === ropeID
      );
      // var ropeIndex = this.facList[facIndex].ropeList.indexOf(e);
      var ropetype = e.rope;
      var ropename = e.ropen;

      this.$store.commit("setInspectingRope", [
        ropeID,
        fac,
        ropename,
        ropetype
      ]);
      this.$store.commit("setInpectionID", ropeID);
      this.$store.commit("setIDCounters", [
        this.idRopeCounter,
        this.id,
        this.idInspection
      ]);
      this.$router.push("Info");
    },
    setFacID(fID, item) {
      console.log("setFacID", fID);
      this.expanded = [];
      this.expanded.push(item);
      console.log(this.expanded);
      this.tampID = fID;
      let array_pos = this.facList.findIndex( x => x.id == fID);
      this.ropesOfFacList = this.facList[array_pos].ropeList;
    },
    close() {
      this.dialog = false;
    },
    closeHelp() {
      this.dialogHelp = false;
    },
  },
  computed: {
    facList: function (){
      return this.$store.state.facilityList;
    }
  },
  created() {
    if (this.$store.state.isOnline) {
      this.idRopeCounter = this.$store.state.ropeIDCounter;
      this.id = this.$store.state.facIDCoutner;
      this.idInspection = this.$store.state.inspectionIDCounter;
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.AddFacility {
  background-color: white;
  width: 60%;
  margin: 0% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
}

.txtField {
  width: 150%;
}

.Heading {
  font-size: 200%;
  margin-left: auto;
  margin-right: auto;
}

#addBtn {
  margin-left: 80%;
}

#btnAddRope {
  margin-left: 120%;
}

@media only screen and (max-width: 300px) {
  .txtField {
    width: 200%;
  }
}

.tdFontSize {
  font-size: 110%;
}

#btnInspection {
  margin-right: 200%;
}

#FacAdd {
  left: 50%;
}

.vTable {
  float: none;
  width: 95%;
  margin-top: 5%;
  margin-left: auto;
  margin-right: auto;
  border: 2px solid black;
  border-radius: 5px;
}

.v-dialog__container {
    display: unset; 
}

.test:hover{
  background-color:red;
}

</style>
